<!--首页 金额占比饼图-->
<template>
	<div
	    v-loading="loading" 
	    element-loading-text="正在加载中..."
	    element-loading-spinner="el-icon-loading"
	    element-loading-background="rgba(23, 40, 90)" style="display: flex;justify-content: center;align-items: center;width: 100%;height: 100%;padding: 5% 2%">
	     <div ref="accountedEcharts" style="width:98%;height:95%" class="center" />
	</div>
</template>

<script>
import { mapState } from "vuex";
import store from "@/store";
import Public from "@/public";
const echarts = require("echarts");
export default {
    data() {
        return {
            orderSummaryDatas: [],
            siteName: [],
            powerData: [],
            chart: null,
			loading: true,
        };
    },
    computed: {
        ...mapState(["theme", "siteOrderSummary","multiple"]),
    },
    mounted() {
		this.getSiteOrderSummary()
        this.chart = echarts.init(this.$refs.accountedEcharts,'dark');
    },
    watch: {
        siteOrderSummary: {
            handler(val) {
                this.orderSummaryDatas = JSON.parse(JSON.stringify(val));
                this.siteName = [];
                this.powerData = [];
                this.dealData(this.orderSummaryDatas);
            },
            deep: true,
        },
    },
    methods: {
        dataEcharts() {
            this.chart.setOption({
				backgroundColor: "#00093a",
                title: {
					show: false,
				},
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} ({d}%)",
                    confine: true,
                },
                legend: {
                    // orient : 'vertical',
                    // x: "center",
					show: false,
                },
                toolbox: {
                    show: true,
                    right: "5%",
                    top: "5%",
                    feature: {
                        saveAsImage: { show: true },
                        // restore: { show: true },
                    },
                },
                calculable: true,
                series: [
                    {
                        name: "碳排放量减少",
                        type: "pie",
                        radius: "55%",
                        // center: ["10%", "100%"],
                        top: "3%",
                        width: "90%",
                        left: "5%",
                        // bottom: "20%",
                        data: this.powerData,
                    },
                ],
            });
        },
        dealData(orderSummaryDatas) {
            if (!orderSummaryDatas) {
                return;
            }
            orderSummaryDatas.sort(Public.createComprisonFunction("money"));
            if (orderSummaryDatas.length > 10) {
                orderSummaryDatas.slice(0, 10);
            }
            for (let i = 0; i < orderSummaryDatas.length; i++) {
                this.siteName.push(orderSummaryDatas[i].name);
                this.powerData.push({
                    value: Number((orderSummaryDatas[i].power * 0.997* this.multiple ).toFixed(2)),
                    name: orderSummaryDatas[i].name,
                });
            }
            this.dataEcharts();
        },
		async getSiteOrderSummary() {
			let that = this;
		    let date = new Date()
		    let year = date.getFullYear()
		    let month = date.getMonth()
		    let start_time = new Date(year,month,1).getTime()
		    let end_time = new Date(year,month+1,0).getTime() + 24 * 60 * 60 * 1000
		    let params = {
		        postData: {
		            end_time: parseInt(end_time / 1000),
		            start_time: parseInt(start_time / 1000),
		            sum_type: 2,
		        },
				callback: () => {
				   that.loading  = false;
				},
		    };
		    await store.dispatch("getOrderSummary", params);
		},
    },
};
</script>
<style scoped>
.center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>
